'use client';
import { useWishlistCustomerKey } from '@/contexts/wishlistCustomerKeyContext';
import { useWishlistService } from '@/hooks/wishlist/useWishlistService';

export const useWishlistToggle = () => {
  const { useAddProductToWishlist, useRemoveProductFromWishlist, useGetWishlist } = useWishlistService();
  const { customerKey, customerKeyType } = useWishlistCustomerKey();

  const { data: wishlistData } = useGetWishlist({
    customerKey: customerKey,
    customerKeyType: customerKeyType,
  });

  const { mutate: addToWishlist } = useAddProductToWishlist();
  const { mutate: removeFromWishlist } = useRemoveProductFromWishlist();

  const toggleWishlist = (sku: string) => {
    if (!wishlistData) {
      return;
    }

    const isWished = wishlistData.skus.includes(sku);

    if (isWished && customerKey) {
      removeFromWishlist({
        customerKey: customerKey,
        customerKeyType: customerKeyType,
        sku: sku,
      });
    } else {
      addToWishlist({
        customerKey: customerKey,
        customerKeyType: customerKeyType,
        sku: sku,
      });
    }
  };

  return {
    wishlistData,
    toggleWishlist,
  };
};
